import React from 'react';
import { css } from '@emotion/core';
import { thousandSeparator } from './UtilFunctions';

export const NumberHandler = ({ num, ...props }) => {
  const { justify, currency, label, float, suffix, expo, ...rest } = props;

  const numWrapper = css`
    width: 100%;
    display: flex;
    ${justify && `justify-content: ${justify} ;`}
    span {
      margin: 0 2px;
    }
    .number {
    }
    .negative {
      color: red;
    }
  `;

  const formatNumber = React.useMemo(() => {
    const absNum = Math.abs(num).toFixed(0 || float);
    return num < 0 ? (
      <span className="negative number">
        (
        {expo && absNum.toString().length > expo.limit
          ? parseFloat(absNum).toExponential(2)
          : thousandSeparator(absNum)}
        )
      </span>
    ) : (
      <span className="number">
        {expo && absNum.toString().length > expo.limit
          ? parseFloat(absNum).toExponential(2)
          : thousandSeparator(absNum)}
      </span>
    );
  }, [num, float]);

  return (
    <span css={numWrapper} {...rest}>
      {label && <span className="label">{`${label}`}</span>}
      {currency && (
        <span
          style={{ margin: '0px', marginRight: '-2px' }}
          className={num < 0 ? 'negative' : undefined}
        >
          {currency}
        </span>
      )}
      {formatNumber}
      {suffix}
    </span>
  );
};
